import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as React from "react";
import { cx } from "../internal/cx.js";

/**
 * Horizontal or vertical divider. Defaults to `decorative` — the rendered
 * element exposes no semantics to assistive tech. Set `decorative={false}`
 * when the separator carries meaning (e.g. between two unrelated content
 * groups in a list).
 */
export const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(function Separator({ className, decorative = true, orientation = "horizontal", ...props }, ref) {
  return (
    <SeparatorPrimitive.Root
      ref={ref}
      className={cx("cw-v2-separator", `cw-v2-separator--${orientation}`, className)}
      decorative={decorative}
      orientation={orientation}
      {...props}
    />
  );
});
Separator.displayName = "Separator";
